import { render, staticRenderFns } from "./SocialTrafficTable.vue?vue&type=template&id=faa7e3f8&"
import script from "./SocialTrafficTable.vue?vue&type=script&lang=js&"
export * from "./SocialTrafficTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports